import React from "react";
import { Form, Input, DatePicker, Select, Typography } from "antd";

const { Title, Paragraph } = Typography;
const { Option } = Select;

export default function  PaymentInvoice(){
  return (
    <div>
      <Title level={4}>Payment Invoice 2025</Title>
      <Paragraph>
        It is a long established fact that a reader will be distracted by the
        readable content of a page when looking at its layout. The point of
        using Lorem Ipsum is that it has a more-or-less normal distribution of
        letters, as opposed to using 'Content here'.
      </Paragraph>

      <Form
        layout="vertical"
        initialValues={{ select: "No" }}
        style={{ maxWidth: "600px" }}
      >
        <Form.Item
          label="Invoice Number"
          name="invoiceNumber"
          rules={[{ required: true, message: "Please enter the invoice number!" }]}
        >
          <Input placeholder="Enter invoice number" />
        </Form.Item>

        <Form.Item
          label="Effective Date"
          name="effectiveDate"
          rules={[{ required: true, message: "Please select the effective date!" }]}
        >
          <DatePicker style={{ width: "100%" }} format="MM/DD/YYYY" />
        </Form.Item>

        <Form.Item
          label="Select"
          name="select"
          rules={[{ required: true, message: "Please make a selection!" }]}
        >
          <Select>
            <Option value="Yes">Yes</Option>
            <Option value="No">No</Option>
          </Select>
        </Form.Item>
      </Form>
    </div>
  );
};

